import { render, staticRenderFns } from "./ShowContent.vue?vue&type=template&id=21366b5e&scoped=true&"
import script from "./ShowContent.vue?vue&type=script&lang=js&"
export * from "./ShowContent.vue?vue&type=script&lang=js&"
import style0 from "./ShowContent.vue?vue&type=style&index=0&id=21366b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21366b5e",
  null
  
)

export default component.exports